<template>
  <div class="page">
    <div class="nav">
      <span :class="selected == '月分析' ? 'selected' : ''" @click="toggle('月分析')">月分析</span>
      <span>|</span>
      <span :class="selected == '日分析' ? 'selected' : ''" @click="toggle('日分析')">日分析</span>
      <span>|</span>
      <span :class="selected == '明细' ? 'selected' : ''" @click="toggle('明细')">明细</span>
    </div>

    <month v-if="selected == '月分析'"></month>
    
    <day v-if="selected == '日分析'"></day>

    <detail v-if="selected == '明细'"></detail>
  </div>
</template>

<script>
import Month from "@/components/MoneyPaytenestidetailReport/Month.vue";
import Day from "@/components/MoneyPaytenestidetailReport/Day.vue";
import Detail from "@/components/MoneyPaytenestidetailReport/Detail.vue";

export default {
  components: {
    Month,
    Day,
    Detail
  },
  data() {
    return {
      selected: '月分析',
    }
  },
  methods: {
    toggle(val) {
      this.selected = val
    }
  }
}
</script>

<style scoped>
.nav {
  padding: 10px 20px;
  display: flex;
  justify-content: space-around;
  background: var(--weui-BG);
}
.nav .selected {
  color: #38559F;
}
@media screen and (min-width: 500px) {
  .nav {
    display: none;
  }
}
</style>